"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function normalizeIdToOldApi(id) {
    return id.replace(/-/g, '');
}
exports.normalizeIdToOldApi = normalizeIdToOldApi;
exports.guid = function () {
    var id = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line
        var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
    return id;
};
function toNewType(from, mapper) {
    var found = mapper.find(function (d) { return d[1] === from; });
    if (!found) {
        // tslint:disable-next-line:no-console
        console.error(from, mapper);
    }
    return found[0];
}
exports.toNewType = toNewType;
function toOldType(from, mapper) {
    var found = mapper.find(function (d) { return d[0] === from; });
    if (!found) {
        // tslint:disable-next-line:no-console
        console.error(from, mapper);
    }
    return found[1];
}
exports.toOldType = toOldType;
//# sourceMappingURL=utils.js.map